// src/components/select/KPISelector.tsx

import { MenuItem, SxProps, TextField, Theme } from '@mui/material'
import { ChangeEvent } from 'react'

type Props = {
  data?: { label: string; value: string }[]
  label?: string
  variant?: 'standard' | 'outlined' | 'filled'
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  sx?: SxProps<Theme>
  value?: string
}

export const KPISelector = ({
  data = [
    { label: 'Verbrauch', value: 'consumption' },
    { label: 'CO₂', value: 'co2' },
    { label: 'Kosten', value: 'price' },
  ],
  label = 'Einheit',
  variant = 'standard',
  onChange,
  value,
  sx,
  ...rest
}: Props) => (
  <TextField
    label={label}
    select
    variant={variant}
    onChange={onChange}
    value={value}
    {...rest}
  >
    {data.map(item => (
      <MenuItem key={item.value} value={item.value} sx={sx}>
        {item.label}
      </MenuItem>
    ))}
  </TextField>
)
